<template>
  <a v-if="link" :href="link" class="cv-link" target="_blank" rel="noopener">CV</a>
</template>

<script>
export default {
  name: 'CvLink',

  props: {
    link: {
      required: true,
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

a {
  padding: 2px 4px;
  border-radius: 4px;
  border: 1px solid $light-link-color;
  color: $light-link-color;

  &:hover {
    color: $green;
    border-color: $green;
  }
}
</style>
